<ion-card>
  <ion-card-header>
    <ion-card-title>Jogosultságok</ion-card-title>
    <ion-card-subtitle>
      Jogkörönként állítható, ki melyik képernyőt látja. Ugyanezekből a sorokból épül a bal
      oldali menü és a modulok belső fülrendszere is.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="jog-fejlec">
      <ion-select label="Alrendszer" label-placement="stacked" interface="popover" fill="outline"
                  [(ngModel)]="alrendszer" (ionChange)="betolt()">
        <ion-select-option *ngFor="let a of alrendszerek" [value]="a">{{ a }}</ion-select-option>
      </ion-select>

      <ion-input label="Intézmény" label-placement="stacked" fill="outline"
                 [(ngModel)]="intezmeny" (ionBlur)="betolt()"></ion-input>

      <ion-input label="Keresés" label-placement="stacked" fill="outline"
                 placeholder="képernyő neve vagy útvonala" [(ngModel)]="szuro"></ion-input>

      <ion-button fill="outline" (click)="menuHianyBetolt()" [disabled]="menuHianyFut"
                  title="Megnézi, mely menüpontok hiányoznak ennél az intézménynél – csillag joggal is üres marad a menü, ha nincs menüsor">
        <ion-icon slot="start" name="git-compare-outline"></ion-icon>
        Menük pótlása
      </ion-button>

      <ion-button fill="outline" (click)="jogkorNyitva = !jogkorNyitva">
        <ion-icon slot="start" name="people-outline"></ion-icon>
        Jogkörök
      </ion-button>

      <ion-button fill="outline" (click)="alapertek()" [disabled]="mentesFut"
                  title="A kódban ma is érvényes jogokat felveszi az adatbázisba – nem vesz el semmit">
        <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
        Mai állapot feltöltése
      </ion-button>

      <ion-button (click)="mentes()" [disabled]="!valtozottDb || mentesFut">
        <ion-icon slot="start" name="save-outline"></ion-icon>
        {{ mentesFut ? 'Mentés…' : (valtozottDb ? 'Mentés (' + valtozottDb + ')' : 'Nincs változás') }}
      </ion-button>
    </div>

    <div class="jog-allapot" *ngIf="toltodik">
      <ion-spinner name="dots"></ion-spinner><span>Jogosultságok betöltése…</span>
    </div>
    <div class="jog-allapot hiba" *ngIf="!toltodik && hiba">
      <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
    </div>

    <ng-container *ngIf="!toltodik && !hiba">
      <ion-note color="medium" class="jog-sugo">
        A <b>csillag</b> sor mindent enged – akinek megvan, annál a többi pipa nem számít.
        A halvány pipa <i>öröklött</i> jog: a jogkör a fölérendelt jogkörtől kapja, itt nem kell külön bejelölni.
      </ion-note>

      <!-- A pipák és a tényleges jogok eltérhetnek: az öröklés (jogkor.link) és a
           csillag miatt. Ez a panel ugyanazt kérdezi le, amit belépéskor a kliens. -->
      <div class="jog-ellenorzes">
        <span>Mit kap ténylegesen:</span>
        <select [value]="ellenorzottJogkor" (change)="ellenorzes($any($event.target).value)">
          <option value="">– válassz jogkört –</option>
          <option *ngFor="let j of jogkorok" [value]="j.jogkor">{{ j.name || j.jogkor }}</option>
        </select>
        <ion-spinner name="crescent" *ngIf="ellenorzesFut"></ion-spinner>
        <span class="db" *ngIf="ellenorzesLista">{{ ellenorzesLista.length }} jog</span>
        <div class="lista" *ngIf="ellenorzesLista">
          <span class="chip" *ngFor="let u of ellenorzesLista">{{ u }}</span>
          <span *ngIf="!ellenorzesLista.length" class="ures">Ez a jogkör semmit nem lát.</span>
        </div>
        <div class="sugo">
          A lista az öröklést (<b>↳</b> a fejlécben) és a csillagot is tartalmazza, ezért több lehet,
          mint amennyi pipa látszik. Egy felhasználót mindig a <b>legmagasabb</b> jogköre szerint
          bírálunk el, nem a jogkörei összegével. A mentés a felhasználóknál a következő
          oldalbetöltéskor érvényesül, a bal menü viszont csak újbóli belépéskor frissül.
        </div>
      </div>

      <!-- ══ MENÜPÓTLÁS ═══════════════════════════════════════════════════════
           A bal menü a `menu` táblából épül, intézményenként külön sorokkal; az
           access csak szűr rajta. Ha az intézménynél nincs menüsor, a csillag jog
           sem mutat semmit – új intézménynél / feladatellátásnál pontosan ez a tünet. -->
      <div class="jog-panel" *ngIf="menuNyitva">
        <div class="jp-fej">
          <b>Menük pótlása az adatbázisban</b>
          <ion-spinner name="crescent" *ngIf="menuHianyFut"></ion-spinner>
          <ion-button size="small" fill="clear" (click)="menuNyitva = false">Bezár</ion-button>
        </div>

        <div class="jp-sugo">
          A bal menü a <code>menu</code> tábla soraiból épül, <b>intézményenként külön</b>; a jogosultság
          csak szűr rajta. Ezért fordulhat elő, hogy valakinek megvan a <b>csillag</b> joga, a menü mégis
          üres: nincs mit megmutatni. Ez a gomb egy már működő intézmény menüje alapján pótolja a
          hiányzó sorokat – meglévőt nem ír felül és nem töröl. Az <b>újonnan bevezetett képernyők</b>
          (amelyek még egyetlen intézménynél sincsenek felvéve, ezért nincs is honnan másolni) a
          program beépített menükészletéből jönnek – ezek <b>új</b> jelölést kapnak.
        </div>

        <ng-container *ngIf="menuHiany">
          <div class="jp-osszegzes">
            <span>Ennél az intézménynél: <b>{{ menuHiany.sajat_db }}</b> menüsor</span>
            <span>Hiányzik: <b [class.baj]="menuHiany.hianyzik.length">{{ menuHiany.hianyzik.length }}</b></span>
            <span *ngIf="menuHiany.minta">Minta: <b>{{ menuHiany.minta }}</b></span>
            <span *ngIf="menuHiany.beepitett_db">Ebből új képernyő: <b>{{ menuHiany.beepitett_db }}</b></span>
            <span>Ide kerül: <b>{{ menuHiany.cel_intezmeny }}</b></span>
          </div>

          <div class="jp-ures" *ngIf="!menuHiany.hianyzik.length">
            Nincs hiány – ennél az intézménynél minden menüpont fel van véve. Ha valaki mégsem látja
            őket, a jogosultság a szűk keresztmetszet, nem a menü.
          </div>

          <ng-container *ngIf="menuHiany.hianyzik.length">
            <div class="jp-muvelet">
              <ion-button size="small" fill="clear" (click)="menuMind(true)">Mind</ion-button>
              <ion-button size="small" fill="clear" (click)="menuMind(false)">Egyik sem</ion-button>
              <ion-button size="small" (click)="menuPotlas()"
                          [disabled]="menuPotlasFut || !menuValasztott.size">
                <ion-icon slot="start" name="add-circle-outline"></ion-icon>
                {{ menuPotlasFut ? 'Pótlás…' : 'Kijelöltek pótlása (' + menuValasztott.size + ')' }}
              </ion-button>
            </div>

            <div class="jp-lista">
              <label class="jp-tetel" *ngFor="let h of menuHiany.hianyzik" [class.fejlec]="h.fejlec">
                <input type="checkbox" [checked]="menuValasztott.has(h.url)" (change)="menuValt(h.url)" />
                <span class="cim">{{ h.title }}</span>
                <span class="url">{{ h.url }}</span>
                <span class="tag" *ngIf="h.fejlec">csoportfejléc</span>
                <span class="tag uj" *ngIf="h.uj" title="Új képernyő: egyetlen intézménynél sincs felvéve, a beépített menükészletből kerül be.">új</span>
                <span class="tag szulo" *ngIf="h.szulo_url">↳ {{ h.szulo_url }}</span>
              </label>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- ══ JOGKÖRÖK ═════════════════════════════════════════════════════════
           Létrehozás, átnevezés, öröklési kapcsolat és törlés. Az öröklés (link)
           adja a mátrix halvány pipáit: a jogkör a fölérendelt jogait is megkapja. -->
      <div class="jog-panel" *ngIf="jogkorNyitva">
        <div class="jp-fej">
          <b>Jogkörök</b>
          <ion-spinner name="crescent" *ngIf="jogkorFut"></ion-spinner>
          <ion-button size="small" fill="clear" (click)="jogkorNyitva = false">Bezár</ion-button>
        </div>

        <div class="jp-sugo">
          A <b>fölérendelt</b> jogkör engedélyeit a jogkör automatikusan megkapja – ez a mátrix halvány
          pipája. Egy felhasználót mindig a legmagasabb jogköre szerint bírálunk el. Az azonosító
          utólag nem módosítható (a felhasználói rekordokban is ez szerepel), a név és az öröklés igen.
        </div>

        <div class="jp-tabla-burok">
          <table class="jp-tabla">
            <thead>
              <tr>
                <th>Azonosító</th><th>Megjelenő név</th><th>Fölérendelt (öröklés)</th>
                <th>Sorrend</th><th>Admin</th><th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let j of jogkorok">
                <td><code>{{ j.jogkor }}</code></td>
                <td><input type="text" [(ngModel)]="j.name" [ngModelOptions]="{standalone: true}" /></td>
                <td>
                  <select [(ngModel)]="j.link" [ngModelOptions]="{standalone: true}">
                    <option [ngValue]="null">– nincs –</option>
                    <option *ngFor="let sz of valaszthatoSzulo(j.jogkor)" [ngValue]="sz.jogkor">
                      {{ sz.name || sz.jogkor }}
                    </option>
                  </select>
                </td>
                <td><input type="number" class="kicsi" [(ngModel)]="j.sorrend" [ngModelOptions]="{standalone: true}" /></td>
                <td><input type="checkbox" [checked]="j.admin" (change)="j.admin = $any($event.target).checked ? 1 : 0" /></td>
                <td class="muvelet">
                  <ion-button size="small" fill="clear" (click)="jogkorMent(j)" [disabled]="jogkorFut">Mentés</ion-button>
                  <ion-button size="small" fill="clear" color="danger" (click)="jogkorTorol(j)" [disabled]="jogkorFut">Törlés</ion-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="jp-uj">
          <b>Új jogkör</b>
          <input type="text" placeholder="azonosito" [(ngModel)]="ujJogkor.jogkor" [ngModelOptions]="{standalone: true}" />
          <input type="text" placeholder="Megjelenő név" [(ngModel)]="ujJogkor.name" [ngModelOptions]="{standalone: true}" />
          <select [(ngModel)]="ujJogkor.link" [ngModelOptions]="{standalone: true}">
            <option value="">– nincs fölérendelt –</option>
            <option *ngFor="let sz of jogkorok" [value]="sz.jogkor">{{ sz.name || sz.jogkor }}</option>
          </select>
          <input type="number" class="kicsi" [(ngModel)]="ujJogkor.sorrend" [ngModelOptions]="{standalone: true}" />
          <label class="jp-admin">
            <input type="checkbox" [(ngModel)]="ujJogkor.admin" [ngModelOptions]="{standalone: true}" /> admin
          </label>
          <ion-button size="small" (click)="jogkorLetrehoz()" [disabled]="jogkorFut">
            <ion-icon slot="start" name="add-outline"></ion-icon> Létrehozás
          </ion-button>
        </div>
        <div class="jp-sugo halvany">
          Az azonosító csak kisbetű, szám és aláhúzás lehet. Létrehozás után a jogkör azonnal
          megjelenik a mátrix oszlopai közt – jogokat ott adj neki.
        </div>
      </div>

      <div class="jog-tabla-burok">
        <table class="jog-tabla">
          <thead>
            <tr>
              <th class="pont">Képernyő</th>
              <th *ngFor="let j of jogkorok" [title]="j.jogkor">
                {{ j.name || j.jogkor }}
                <small *ngIf="j.link">↳ {{ j.link }}</small>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let cs of csoportok">
              <tr class="jog-csoport" *ngIf="szurtPontok(cs).length">
                <td [attr.colspan]="jogkorok.length + 1">{{ cs.nev }}</td>
              </tr>
              <tr *ngFor="let p of szurtPontok(cs)">
                <td class="pont">
                  <span class="cim">{{ p.cim }}</span>
                  <small class="url">{{ p.url }}</small>
                </td>
                <td *ngFor="let j of jogkorok" class="cella"
                    [class.mindent]="mindentLat(j.jogkor) && p.url !== '*'"
                    [class.fejlec-hianyzik]="fejlecHianyzik(j.jogkor, p)">
                  <ion-checkbox [checked]="engedve(j.jogkor, p.url)"
                                (ionChange)="valt(j.jogkor, p.url)"></ion-checkbox>
                  <span class="oroklott" *ngIf="oroklott(j, p.url)" title="Öröklött jog a fölérendelt jogkörtől">✓</span>
                  <!-- A bal menü a csoportfejlécen keresztül rajzol: fejléc-jog nélkül a
                       menüpont nem jelenne meg a megszokott helyén. -->
                  <span class="fejlec-jel" *ngIf="fejlecHianyzik(j.jogkor, p)"
                        [title]="fejlecSugo(p)">!</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
